module.exports = __webpack_public_path__ + "img/CM-MC-25-Hyundai-Modern.44bee75a.jpg";